import { PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import KioskCategory from "./KioskCategory";
import KioskLayout from "./KioskLayout";

export interface KioskMenuProps extends PropsWithChildren {}

const KioskMenu = ({}: KioskMenuProps) => {
  const { id, categoryId } = useParams<{ id: string; categoryId: string }>();

  return (
    <KioskLayout>
      <KioskCategory id={id} categoryId={categoryId} />
    </KioskLayout>
  );
};

export default KioskMenu;
